import { render, staticRenderFns } from "./DetailListUnderDirectBanking.vue?vue&type=template&id=019bb66c"
import script from "./DetailListUnderDirectBanking.vue?vue&type=script&lang=js"
export * from "./DetailListUnderDirectBanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports